import {createAction} from 'redux-actions';
import GreenLeafApi from '../GreenLeafApi';

const deleteCompany = createAction('DELETE_COMPANY', id => id, () => ({ async: true, httpMethod: GreenLeafApi.Company.delete }));

export { deleteCompany };


// WEBPACK FOOTER //
// ./src/components/utils/actions/companies.js